import React, { Component } from 'react';
import './css/bootstrap.css';
import './css/font-awesome.min.css'
import './css/style.css'
import './css/style.scss'
import './css/responsive.css';
import './fonts/fontawesome-webfont.ttf'
import './fonts/fontawesome-webfont.woff'
import './fonts/fontawesome-webfont.woff2'
import './fonts/octin_sports_rg.ttf'
import Home from './containers/Home'
import { BrowserRouter, Routes, Route } from 'react-router-dom'

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
            <Route index element={<Home />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;